import React, { useState, useEffect } from 'react';
import StepWizard from 'react-step-wizard';
import startIcon from '../Assets/images/powtorz.png';
import gobackIcon from '../Assets/images/wstecz.png';

import createEmbedImg from '../Assets/images/embed.gif';
import highlightImg from '../Assets/images/highlight_elements.gif';
import pathwaysImg from '../Assets/images/pathways.gif';

import expGoogleSlideImg from '../Assets/images/experience_google_slides.gif';
import customizeImg from '../Assets/images/personalize_and_customize.gif';
import analyticsImg from '../Assets/images/analytics.gif';

import educateImg from '../Assets/images/educate.gif';
import followImg from '../Assets/images/follow_up_with_video.gif';
import trackImg from '../Assets/images/track__analytics.gif';

import sellMoreImg from '../Assets/images/Increase_sales_sell_more_products.gif';

import recordAVideoImg from '../Assets/images/churn_record_a_video.gif';
import createVideoPathImg from '../Assets/images/churn_needs_video_paths.gif';
import sendVideoByEmailImg from '../Assets/images/churn_send_videos_by_email.gif';

import captureYourScreenImg from '../Assets/images/churn_assistance_capture_your_screen.gif';
import dynamicLinkImg from '../Assets/images/churn_assistance_personalized_dynamic_link.gif';
import videoWalkthroughImg from '../Assets/images/churn_assistance_video_walkthroughs.gif';

import createNewVideoImg from '../Assets/images/leads_create_new_video.gif';
import addIframeImg from '../Assets/images/leads_add_iframe.gif';
import embedVideoImg from '../Assets/images/leads_embed_videos.gif';

import changePathImg from '../Assets/images/analyze_edit_your_videos.gif';
import customerPathImg from '../Assets/images/clickstreams_upload_your_video.gif';
import videoAnalyticsImg from '../Assets/images/clickstreams_view_video_analytics.gif';

import sellMoreUploadImg from '../Assets/images/Increaes_sales_sell_more_upload_own.gif';
import sellMoreEmbedImg from '../Assets/images/Increase_sales_sell_more_embed_videos.gif';
import sellMoreDirectlyImg from '../Assets/images/Increase_sales_sell_directly.gif';

import moreDealsAnalyticsImg from '../Assets/images/Increase_sales_close_more_deals_analytics.gif';
import moreDealsGoogleSlideImg from '../Assets/images/Increase_sales_close_more_deals_google_slides.gif';
import moreDealsPersonalizeImg from '../Assets/images/Increase_sales_close_more_deals_personalize.gif';

import increaseSalesLoopImg from '../Assets/images/increase_sales_loop.gif';
import onboardNewCustomersLoopImg from '../Assets/images/onboard_new_customers_loop.gif';
import reduceChurnLoopImg from '../Assets/images/reduce-churn_loop.gif';

import TagManager from 'react-gtm-module';

export default function Onboarding({ isVisible, handleClose }) {
	const [showButtons, setShowButtons] = useState(true);
	const [firstName, setFirstName] = useState();
	const handleInteractive = () => {
		window.open('https://app.videommerce.com/interactive');
	};
	const handleBookDemo = () => {
		window.open('https://videommerce.com/get-a-personalized-demo/');
	};
	const handlerStartFree = () => {
		window.open('https://app.videommerce.com/register');
	};

	const sendEvents = (labela) => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'Onboarding',
				event_label: labela,
			},
		});
	};

	const handleUrl = () => {
		var currentUrl = document.referrer;
		var videommerceUrl = 'https://videommerce.com/';

		if (currentUrl == videommerceUrl) {
			setShowButtons(true);
		} else {
			setShowButtons(false);
		}
	};

	useEffect(() => {
	  window.addEventListener("message", (event) => {
	    let receivedData = {};
	    try {
	      receivedData = JSON.parse(event.data);
	    } catch (error) {
	      return false;
	    }

	    if (receivedData.action) {
	       setFirstName(receivedData.data.firstName)
	    }
	  });

	}, []);

	useEffect(() => {
	  window.top.postMessage(
	        JSON.stringify({
	          action: "get_user_name",
	        }),
	        "*"
	    );
	 }, [])

	return (
		<div>
			<StepWizard initialStep={1}>
				<WhatDoYouWantToDo
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
					firstName={firstName}
				/>

				<IncreaseSales
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<GenerateNewLeads
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<SellMoreProducts
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<CloseMoreDeals
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>

				<OnboardNewCustomers
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<HookNewVisitors
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<PersonalizedExperience
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<TurnUsersIntoCustomers
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>

				<ReduceChurn
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<AnalyseClickstreams
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<AskAboutCustomer
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
				<StrengthenCustomerLoyalty
					handleInteractive={handleInteractive}
					handleBookDemo={handleBookDemo}
					handlerStartFree={handlerStartFree}
					sendEvents={sendEvents}
					handleUrl={handleUrl}
					showButtons={showButtons}
				/>
			</StepWizard>
		</div>
	);
}

const HeaderTemplate = ({ children }) => (
	<div className="col-md-6">
		<div className="video-container h-100 d-flex flex-column align-items-center p-5">
			{children}
		</div>
	</div>
);

const ContentTemplate = ({ children }) => (
	<div className="col-md-6 onboarding__content">
		<div className="onboarding-info">{children}</div>
	</div>
);

const WhatDoYouWantToDo = ({
	user,
	maxHeight,
	handleUrl,
	handleBookDemo,
	showButtons,
	sendEvents,
	firstName,
	...props
}) => {
	const [tab, setTab] = useState(1);
	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<HeaderTemplate>
					{showButtons === false ? (
						<>
							<h3 className="video-title" style={{marginBottom: "2rem"}}>
								{' '}
								{firstName}, What do you want to achieve today?
							</h3>
						</>
					) : (
						<>
							<h2 className="fw-bold mb-4">Hey </h2>
							<h3 className="mb-3">
								What do you want to achieve today?
							</h3>
						</>
					)}
					{tab === 1 && (
						<div className="explain-video">
							<iframe
								id="vep_k0X2vZufcZ0NZa3sspjUObPonOErkCk5occcNUhuVe6yhnzUlL3UnN1EswAlFwXf"
								className="videommerceembeddedplayer"
								style={{
									border: 'none',
									overflow: 'hidden',
									width: '100%',
									height: '100%',
									vwidth: '1920',
									vheight: '1080',
								}}
								src="https://plays.video/live/k0X2vZufcZ0NZa3sspjUObPonOErkCk5occcNUhuVe6yhnzUlL3UnN1EswAlFwXf"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>
							<script
								type="text/javascript"
								src="https://plays.video/iframe-prop.js"
							></script>
						</div>
					)}
					{tab === 2 && (
						<div className="sell-video">
							<iframe
								id="vep_Rciw7XPg9eZmlZH6fdv5XzJNJoU5DqSNTS3LUjWwAODdwIZVTEpxQYFCsqNzTMfZ"
								className="videommerceembeddedplayer"
								style={{
									border: 'none',
									overflow: 'hidden',
									width: '100%',
									height: '100%',
									vwidth: '1920',
									vheight: '1080',
								}}
								src="https://plays.video/live/Rciw7XPg9eZmlZH6fdv5XzJNJoU5DqSNTS3LUjWwAODdwIZVTEpxQYFCsqNzTMfZ"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>{' '}
							<script
								type="text/javascript"
								src="https://plays.video/iframe-prop.js"
							></script>
						</div>
					)}
					{tab === 3 && (
						<div className="automate-video">
							<iframe
								id="vep_FA9pb75QLQtCXp21QW8pp4qozhBZv8owS11wJM9tAjcRwXecwWdbXgtpJ8nC6Wmf"
								className="videommerceembeddedplayer"
								style={{
									border: 'none',
									overflow: 'hidden',
									width: '100%',
									height: '100%',
									vwidth: '1920',
									vheight: '1080',
								}}
								src="https://plays.video/live/FA9pb75QLQtCXp21QW8pp4qozhBZv8owS11wJM9tAjcRwXecwWdbXgtpJ8nC6Wmf"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>{' '}
							<script
								type="text/javascript"
								src="https://plays.video/iframe-prop.js"
							></script>
						</div>
					)}
					<div className="create-video mt-4">
						<button
							type="button"
							className=" start-over fw-bold"
							onClick={() =>
								window.open(
									'https://app.videommerce.com/movies/create',
									'_blank'
								)
							}
						>
							{/* <span className="start-over_icon">
                  <img src={startIcon} />
                </span> */}
							Create Now
						</button>
						{/*
              <button type="button" className="create-video-btn onboarding__button">
                <div> Use our ESA framework</div>
                <small>
                  (Explain/Sell/Automate) to grow your business
                  during 3
                  crucial stages
              </small>
              <ul>
                <li>Explain
The starting point. You need to spread the word about your new features, products or services and convince your viewers why it will benefit them and how.
Look right and check how to explain>>></li>
              </ul>
              </button> */}

						<div className="onboarding-info">

							<ol className="create-list">
                {tab=== 1 && (

								<li

									className=" onboarding__button active explain-list"
								>
									<div>
										<h2>Explain</h2>
                  						The starting point. You need to
										spread the word about your new features,
										products or services and convince your
										viewers why it will benefit them and
										how. Look right and check how to
                    explain
                    <i class="fa fa-angle-double-right"></i>
									</div>
								</li>
                )}
                {tab===2 &&(

                  <li
                    type="button"
                    className=" onboarding__button active sell-list"
                  >
                    <div>
                      <h2>Sell</h2>
  Reap the benefits of your hard work and start seeing the results of that by increasing your sales in every direction.
                      Look right and check how to sell.
                      <i class="fa fa-angle-double-right"></i>
                    </div>
                  </li>
                )}
                {tab===3 &&(

                    <li
                      type="button"
                      className=" onboarding__button active automate-list"
                    >
                      <div>
						  <h2>Automate</h2>
    You made a sale, great!. Now you should automate this business process with video
    Look right and check how to automate.
    <i class="fa fa-angle-double-right"></i>

    </div>
                    </li>
                )}
							</ol>

							<h3 className="mb-3 text-center">
								Use our ESA framework (Explain/Sell/Automate) to
								grow your business during 3 crucial stages
							</h3>
						</div>
					</div>
				</HeaderTemplate>
				<ContentTemplate>
					<h3 className="mb-3 text-center" style={{marginTop: "0px"}}>
						Please choose today's outcome
					</h3>
					<div className="tabs mt-4 explain onboarding__button">
						<button
							className={`onboarding__tab ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Explain
						</button>
						<button
							className={`onboarding__tab ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Sell
						</button>
						<button
							style={{ borderRight: 'none' }}
							className={`onboarding__tab ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Automate
						</button>
					</div>

					{tab === 1 && (
						<div id="explain">
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Social Media video</div>
								<small>
									{' '}
									Create a video about your “NEW” product or
									service. Upload and fine tune your existing
									file with text, images, animation and
									beyond. Resize your finished content to
									enhance posts on LinkedIn, Facebook,
									Instagram, Twitter or Tik Tok.{' '}
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Make your video interactive</div>
								<small>
									Be like Netflix in your industry. Ask your
									viewers what they want to watch. Just add
									buttons to your “NEW thing” video where you
									underline 2-3 desired outcomes. Embed the
									video on your website and measure which
									steps were chosen by your audience.
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Personalize video emails</div>
								<small>
									Engage in seconds by adding a first name to
									the video and send it by email to all of
									your email contacts. Create unique links
									based on a csv file to accelerate your
									business proces
								</small>
							</button>
						</div>
					)}

					{tab === 2 && (
						<div id="sell">
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Social Media video</div>
								<small>
									create a sales video about your offer and
									post it on your favorite Social Media
									channels. Make this content shorter to run
									ads. Drive traffic to your website or
									ecommerce store.
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Make your video interactive</div>
								<small>
									Turn viewers into paying customers. Add lead generation form to the video to enrich your sales opportunities with new contacts. Sell more products directly with embedded shopping carts inside your sales video.
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Personalize video emails</div>
								<small>
									You are still working on the same sales
									video. Present a special price, discounts to
									your CRM contacts. Upload a .csv file with
									their first name, special offer and generate
									unique links in seconds to the personalized
									videos.
								</small>
							</button>
						</div>
					)}
					{tab === 3 && (
						<div id="automate">
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Social Media video</div>
								<small>
									Save hours by transcribing your videos. Do
									it automatically and add captions to your
									videos on your Socail Media plaforms. Be
									understand by your audience.
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Make your video interactive</div>
								<small>
									Are you selling online? Please don’t update
									prices in your videos manually. Add XML feed
									and make it done automatically. Educate your
									website visitors by step-by-step guiding
									them throughout your product and services.
								</small>
							</button>
							<button
								type="button"
								className={` onboarding__button`}
							>
								<div>Personalize video emails</div>
								<small>
									Put attention on autopilot. Segment your
									list and create each audience their own
									video. Set them in your email nurturing
									sequence or as an autoresponder to thank you
									page. Remember to add personalization tags
									from your CRM/mailing system.
								</small>
							</button>
						</div>
					)}
				</ContentTemplate>
			</div>
		</div>
	);
};

const IncreaseSales = ({
	handlerStartFree,
	maxHeight,
	handleUrl,
	handleBookDemo,
	showButtons,
	sendEvents,
	...props
}) => (
	<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
		<div className="row">
			<ContentTemplate>
				<h3 className="mb-6 text-center">How to increase sales: </h3>
				<button
					type="button"
					className={`onboarding__button`}
					onClick={() => {
						sendEvents('Generate new leads');
						props.goToStep(3);
					}}
				>
					<div>Generate new leads</div>
					<small>Nurture and qualify your prospects</small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={`onboarding__button`}
					onClick={() => {
						sendEvents('Sell more products');
						props.goToStep(4);
					}}
				>
					<div>Sell more products</div>
					<small>Turn your ecommerce into a clickable video</small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={`onboarding__button`}
					onClick={() => {
						sendEvents('Close more deals');
						props.goToStep(5);
					}}
				>
					<div>Close more deals</div>
					<small>
						Shine at meetings with interactive presentations
					</small>
					<i className="fa fa-chevron-right" />
				</button>

				<div className="d-flex mt-4">
					<button
						type="button"
						className="go-back fw-bold"
						onClick={() => props.goToStep(1)}
					>
						<span className="go-back_icon">
							<img src={gobackIcon} />
						</span>
						Go back
					</button>
				</div>
			</ContentTemplate>
			<HeaderTemplate>
				<h2 className="fw-bold mb-4">Increase sale</h2>
				<h3 className="mb-3">Seal the deal</h3>
				<img src={increaseSalesLoopImg} />
			</HeaderTemplate>
		</div>
	</div>
);

const GenerateNewLeads = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState('create_video');

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-3 text-center">
						How to generate leads:{' '}
					</h3>

					<ol className="list_element">
						<li
							type="button"
							id="create_video"
							className={`onboarding__button ${
								tab === 'create_video' ? 'active' : 'inactive'
							}`}
							onClick={() => setTab('create_video')}
						>
							Create your video
						</li>

						<li
							type="button"
							id="add_form"
							className={`onboarding__button ${
								tab === 'add_form' ? 'active' : 'inactive'
							}`}
							onClick={() => setTab('add_form')}
						>
							Integrate lead form
						</li>

						<li
							type="button"
							id="embed_website"
							className={`onboarding__button ${
								tab === 'embed_website' ? 'active' : 'inactive'
							}`}
							onClick={() => setTab('embed_website')}
						>
							Embed on Website
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}
						<div className="d-flex mt-4">
							<button
								type="button"
								className=" start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(2)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 'create_video' && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Create new video, upload your own or use a
								YouTube link
							</h3>
							<img src={createNewVideoImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start generating new leads now
							</button>
						</div>
					)}

					{tab === 'add_form' && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Add iframe to the video from your CRM (using a
								popup)
							</h3>
							<img src={addIframeImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>{' '}
								Start generating new leads now
							</button>
						</div>
					)}

					{tab === 'embed_website' && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Embed videos to any website and generate high
								quality leads
							</h3>
							<img src={embedVideoImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>{' '}
								Start generating new leads now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const SellMoreProducts = ({
	handleInteractive,
	handleUrl,
	handleBookDemo,
	showButtons,
	handlerStartFree,
	...props
}) => {
	const [tab, setTab] = useState(1);
	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto' }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-3 text-center">
						How to sell more products:{' '}
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							<div>Create , Upload your exciting video</div>
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							<div>Mark SKUs with interactive elements</div>
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							<div>Send links to your customers</div>
						</li>

						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}

						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(2)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Create new video, upload your own or use a
								YouTube link
							</h3>
							<img src={sellMoreUploadImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>{' '}
								Start selling more products now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Sell directly from your video by connecting
								products with your shopping cart
							</h3>
							<img src={sellMoreDirectlyImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start selling more products now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Send links to your customers or embed videos on
								your product page to sell more products
							</h3>
							<img src={sellMoreEmbedImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start selling more products now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const CloseMoreDeals = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to close more deals:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Upload Google Slides
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Customize new videos
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Amaze during a presentation
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}
						<div className="d-flex mt-4">
							<button
								type="button"
								className=" start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(2)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Turn Google Slides into an editable video
							</h3>
							<img src={moreDealsGoogleSlideImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start closing more deals now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Personalize and Customize your video
							</h3>
							<img src={moreDealsPersonalizeImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>{' '}
								Start closing more deals now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								After a meeting, send a link to your video and
								track viewings, clicks, time and close more
								deals
							</h3>
							<img src={moreDealsAnalyticsImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>{' '}
								Start closing more deals now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const OnboardNewCustomers = ({
	handlerStartFree,
	maxHeight,
	handleUrl,
	handleBookDemo,
	showButtons,
	sendEvents,
	...props
}) => (
	<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
		<div className="row">
			<ContentTemplate>
				<h3 className="mb-6 text-center">
					How to Onboard new Customers:
				</h3>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Hook new visitors immediately');
						props.goToStep(7);
					}}
				>
					<div>Hook new visitors immediately</div>
					<small>Grab attention with eye catching videos </small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Personalize the experience to every user');
						props.goToStep(8);
					}}
				>
					<div>Personalize the experience to every user</div>
					<small>
						Welcome new users by personalizing videos to them
					</small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Turn users into customers');
						props.goToStep(9);
					}}
				>
					<div>Turn users into customers</div>
					<small>Teach with easy-to-follow interactive tours</small>
					<i className="fa fa-chevron-right" />
				</button>

				<div className="d-flex mt-4">
					<button
						type="button"
						className="go-back fw-bold"
						onClick={() => props.goToStep(1)}
					>
						<span className="go-back_icon">
							<img src={gobackIcon} />
						</span>
						Go back
					</button>
				</div>
			</ContentTemplate>
			<HeaderTemplate>
				<h2 className="fw-bold mb-4">Onboard new customers</h2>
				<h3 className="mb-3">Deliver an amazing experience</h3>
				<img src={onboardNewCustomersLoopImg} />
			</HeaderTemplate>
		</div>
	</div>
);

const HookNewVisitors = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState('create_upload');

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to hook your visitors:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 'create_upload' ? 'active' : 'inactive'
							}`}
							onClick={() => setTab('create_upload')}
						>
							Record your screen
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 'highlight_element'
									? 'active'
									: 'inactive'
							}`}
							onClick={() => setTab('highlight_element')}
						>
							Highlight important sections
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 'create_layer' ? 'active' : 'inactive'
							}`}
							onClick={() => setTab('create_layer')}
						>
							Embed on landing page
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}
						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(6)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>

				<HeaderTemplate>
					{tab === 'create_upload' && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Create a video about your product
							</h3>
							<img src={createEmbedImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start hooking new visitors now
							</button>
						</div>
					)}

					{tab === 'highlight_element' && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Enhance and highlight important parts to
								elaborate on
							</h3>
							<img src={highlightImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start hooking new visitors now
							</button>
						</div>
					)}

					{tab === 'create_layer' && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Turn your website into a sales machine
							</h3>
							<img src={pathwaysImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start hooking new visitors now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const PersonalizedExperience = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to Personalize videos for every user:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Drag’n’drop elements
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Copy dynamic link
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Send by email
						</li>

						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}
						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(6)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>

				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Add personalized elements like: first name,
								company name,watched video time
							</h3>
							<img src={expGoogleSlideImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start personalizing videos for every user now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Create dynamic links in the{' '}
								<span className="fw-bold interactive-text">
									Share
								</span>{' '}
								section. Add more elements if you like
							</h3>
							<img src={customizeImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start personalizing videos for every user now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Paste the link to your email in your marketing
								automation platform
							</h3>
							<img src={analyticsImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start personalizing videos for every user now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const TurnUsersIntoCustomers = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);
	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to turn users into customers:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Teach about your product
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Track interactions
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Remind about yourself
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}

						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(6)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>

				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Educate using interactive videos with multiple
								paths to keep the customer engaged
							</h3>
							<img src={educateImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start turning users into customers now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Track what users interact with the most and
								improve your onboarding process
							</h3>
							<img src={trackImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start turning users into customers now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Create as many interactive videos and images as
								you want to follow up customers
							</h3>
							<img src={followImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start turning users into customers now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const ReduceChurn = ({
	handlerStartFree,
	maxHeight,
	handleUrl,
	handleBookDemo,
	showButtons,
	sendEvents,
	...props
}) => (
	<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
		<div className="row">
			<ContentTemplate>
				<h3 className="mb-6 text-center">How to reduce churn: </h3>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Analyze clickstreams');
						props.goToStep(11);
					}}
				>
					<div>Analyze clickstreams</div>
					<small>Measure the most common drop-out paths</small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Ask about customer wants and needs');
						props.goToStep(12);
					}}
				>
					<div>Ask about customer wants and needs</div>
					<small>Get quick answers to NPS and surveys</small>
					<i className="fa fa-chevron-right" />
				</button>
				<button
					type="button"
					className={` onboarding__button`}
					onClick={() => {
						sendEvents('Deliver 24/7 assistance');
						props.goToStep(13);
					}}
				>
					<div>Deliver 24/7 assistance</div>
					<small>Support Customers with interactive Video FAQs</small>
					<i className="fa fa-chevron-right" />
				</button>

				<div className="d-flex mt-4">
					<button
						type="button"
						className="go-back fw-bold"
						onClick={() => props.goToStep(1)}
					>
						<span className="go-back_icon">
							<img src={gobackIcon} />
						</span>
						Go back
					</button>
				</div>
			</ContentTemplate>
			<HeaderTemplate>
				<h2 className="fw-bold mb-4">Reduce churn</h2>
				<h3 className="mb-3">Deliver amazing experience</h3>
				<img src={reduceChurnLoopImg} />
			</HeaderTemplate>
		</div>
	</div>
);

const AnalyseClickstreams = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to analyze click streams:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Create customer paths
						</li>

						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Analyze interactions
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Change the paths
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}
						<div className="d-flex mt-4">
							<button
								type="button"
								className=" start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="onboarding__link go-back fw-bold"
								onClick={() => props.goToStep(10)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Create interactive videos about your product,
								selling process, NPS or most asked questions
							</h3>
							<img src={customerPathImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start analyzing click streams now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Analyze views, interactions, time, drop-outs,
								streams
							</h3>
							<img src={videoAnalyticsImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start analyzing click streams now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Edit your videos or paths based on customer
								response
							</h3>
							<img src={changePathImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start analyzing click streams now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const AskAboutCustomer = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);

	useEffect(() => {
		handleUrl();
	}, []);

	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to ask customers about their needs:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Record videos
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Create customer paths
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Send videos
						</li>
						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}

						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="go-back fw-bold"
								onClick={() => props.goToStep(10)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Record a video with relevant questions
							</h3>
							<img src={recordAVideoImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start asking customers about wants and needs now
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Connect videos to create a streams (paths)
							</h3>
							<img src={createVideoPathImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start asking customers about wants and needs now
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Send videos by email, embed on website or on
								unsubscribe link
							</h3>
							<img src={sendVideoByEmailImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start asking customers about wants and needs now
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};

const StrengthenCustomerLoyalty = ({
	user,
	maxHeight,
	handleUrl,
	handlerStartFree,
	handleInteractive,
	handleBookDemo,
	showButtons,
	...props
}) => {
	const [tab, setTab] = useState(1);

	useEffect(() => {
		handleUrl();
	}, []);
	return (
		<div style={{ overflow: 'hidden auto', maxHeight: maxHeight }}>
			<div className="row">
				<ContentTemplate>
					<h3 className="mb-6 text-center">
						How to deliver 24/7 assistance:
					</h3>
					<ol className="list_element">
						<li
							type="button"
							className={` onboarding__button ${
								tab === 1 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(1)}
						>
							Create answers
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 2 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(2)}
						>
							Capture your screen
						</li>
						<li
							type="button"
							className={` onboarding__button ${
								tab === 3 ? 'active' : 'inactive'
							}`}
							onClick={() => setTab(3)}
						>
							Personalized dynamic link to your CRM customers
						</li>

						{showButtons === true && (
							<div className="main-buttons">
								<div className="mt-4">
									<button
										type="button"
										className="fw-bold start_free"
										onClick={handlerStartFree}
									>
										Start for free
									</button>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="onboarding__link fw-bold book-demo"
										onClick={handleBookDemo}
									>
										Book a demo
									</button>
								</div>
							</div>
						)}

						<div className="d-flex mt-4">
							<button
								type="button"
								className="start-over fw-bold"
								onClick={() => props.goToStep(1)}
							>
								<span className="start-over_icon">
									<img src={startIcon} />
								</span>
								Start over
							</button>
							<button
								type="button"
								className="go-back fw-bold"
								onClick={() => props.goToStep(10)}
							>
								<span className="go-back_icon">
									<img src={gobackIcon} />
								</span>
								Go back
							</button>
						</div>
					</ol>
				</ContentTemplate>
				<HeaderTemplate>
					{tab === 1 && (
						<div className="gif_create_video">
							<h3 className="text-center mb-3">
								Create answers to your most common questions via
								interactive walkthrough
							</h3>
							<img src={videoWalkthroughImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start delivering 24/7 assistance
							</button>
						</div>
					)}

					{tab === 2 && (
						<div className="gif_add_form right-gif">
							<h3 className="text-center mb-3">
								Capture your screen and make a how to video
								should they need it
							</h3>
							<img src={captureYourScreenImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start delivering 24/7 assistance
							</button>
						</div>
					)}

					{tab === 3 && (
						<div className="gif_embed_website right-gif">
							<h3 className="text-center mb-3">
								Personalized dynamic link to your CRM customers
							</h3>
							<img src={dynamicLinkImg} />
							<button
								type="button"
								className="btn-interactive text-white mt-5"
								onClick={handleInteractive}
							>
								<span className="fw-bold interactive-text"></span>
								Start delivering 24/7 assistance
							</button>
						</div>
					)}
				</HeaderTemplate>
			</div>
		</div>
	);
};
